module.exports = __webpack_public_path__ + "img/black.d4bbf788.svg";